module.exports = __webpack_public_path__ + "img/grand-pool-4.0600974c.jpg";